module.exports = __webpack_public_path__ + "img/school-gedung.eff3485c.png";